module.exports = __webpack_public_path__ + "img/masscoms_6.693217e7.png";